import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import { PhoneNumbersManager } from "@/components/admin/PhoneNumbersManager";

const PhoneNumbers = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <>
      <SEOHead 
        title="Phone Numbers Management"
        description="Manage Twilio phone numbers and campaign tracking"
      />
      
      <PhoneNumbersManager />
    </>
  );
};

export default PhoneNumbers;
